import { PrinterFormValues, PrinterItem } from './types';

export const convertToFormValues = (data: PrinterItem): PrinterFormValues => {
  const { categories, ...rest } = data;

  const categoriesValue: string[] = [];
  categories.forEach(({ categoryId, orderTypes }) => {
    categoriesValue.push(
      ...orderTypes.map(({ orderTypeId }) => `${categoryId}_${orderTypeId}`)
    );
  });

  return {
    ...rest,
    categories: categoriesValue,
  };
};

export const convertFromFormValues = (values: PrinterFormValues) => {
  const { categories, ...rest } = values;

  const orderTypePerCategoryId: Record<
    string,
    PrinterItem['categories'][number]
  > = {};
  categories.forEach((value) => {
    const [categoryId, orderTypeId] = value.split('_');
    if (!orderTypePerCategoryId[categoryId]) {
      orderTypePerCategoryId[categoryId] = {
        categoryId,
        orderTypes: [],
      };
    }

    orderTypePerCategoryId[categoryId].orderTypes.push({ orderTypeId });
  });

  return {
    ...rest,
    categories: Object.values(orderTypePerCategoryId),
  };
};
